import feathersClient from "../../feathers-client";

const defaultUnfilledShiftReasonPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultUnfilledShiftReasonPaginationFilter = {
	$skip:defaultUnfilledShiftReasonPagination.$skip,
	$limit: defaultUnfilledShiftReasonPagination.$limit
};

export default {
	state:{
		UnfilledShiftReason:[],
		UnfilledShiftReasonPagination:defaultUnfilledShiftReasonPagination,
		UnfilledShiftReasonPaginationFilter:defaultUnfilledShiftReasonPaginationFilter
	},
	getters:{
		setUnfilledShiftReasonPage:(state) => {
			const {$limit, $skip} = state.UnfilledShiftReasonPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_UNFILLED_SHIFT_REASON:(state,data) => {state.UnfilledShiftReason = data;},
		SET_UNFILLED_SHIFT_REASON_PAGINATION:(state, data) => {state.UnfilledShiftReasonPagination = {...state.UnfilledShiftReasonPagination, ...data};},
		SET_UNFILLED_SHIFT_REASON_PAGINATION_FILTER:(state,data) => {state.UnfilledShiftReasonPaginationFilter  = {...state.UnfilledShiftReasonPaginationFilter, ...data};}

	},
	actions:{
		setUnfilledShiftReasonListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.UnfilledShiftReasonPagination.$limit;
			commit('SET_UNFILLED_SHIFT_REASON_PAGINATION', { $skip });
			commit('SET_UNFILLED_SHIFT_REASON_PAGINATION_FILTER', { $skip });
		},

		getUnfilledShiftReason: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/unfilled-shifts-reasons').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_UNFILLED_SHIFT_REASON',results.data);
			commit('SET_UNFILLED_SHIFT_REASON_PAGINATION', {total :results.total})
			return results.data;
		},
		createUnfilledShiftReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/unfilled-shifts-reasons').create(data,{
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		updateUnfilledShiftReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/unfilled-shifts-reasons').patch(data.id, data,{
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			
			return results;
		},
		deleteUnfilledShiftReason: async ({rootGetters},id) => {
			
			const results = await feathersClient.service('/api/v3/unfilled-shifts-reasons').remove(id,{
				query: {
					$role: rootGetters.currentUserRole,
				},
				
			});
			
			return results;
		},
		getUnfilledShiftReasonById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/unfilled-shifts-reasons').get(id,{
				query: {
					$role: rootGetters.currentUserRole,
				},
			});

			return results
		},
		getAllUnfilledShiftReasonForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/unfilled-shifts-reasons').find({
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getAllUnfilledShiftsReason: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/unfilled-shifts-reasons').find({
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results.data;
		}

	}
}
